/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const AddNewUserPage = lazyLoad(
  () => import('./index'),
  module => module.AddNewUserPage,
);
